import './App.css';
import {RouterProvider} from "react-router-dom";
import {router} from "./pages/router";
import {StorageContextProvider} from "./storage/StorageContext";
import { i18nInit } from './commons/i18n/init';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import 'moment/locale/fr';
import { useEffect } from 'react';
import FakeStore from './commons/FakeStore';

const storedLang = (() => {
	try {
		const stored = JSON.parse(localStorage.getItem('__chooz_store') || '{}');
		return stored.language || 'fr';
	} catch (e) {
		return 'fr';
	}
})();
i18nInit(storedLang);
moment.locale(storedLang);

function App() {

	useEffect(() => {
		let browserId = localStorage.getItem('worker-js-http-id');
		if (!browserId || browserId.trim() === 'text') {
			browserId = uuidv4();
			localStorage.setItem('worker-js-http-id', browserId);
		}
		FakeStore.browserId = browserId;
	}, []);

	return (
		<StorageContextProvider>
			<RouterProvider router={router} />
		</StorageContextProvider>
	);
}

export default App;
